<div class="header-container">
  <dcc-page-title
    class="header-container__header"
    title="Add Version"></dcc-page-title>
  <div
    class="header-container__close"
    type="button"
    (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </div>
</div>

<div class="input-container">
  <div class="input">
    <label
      class="lx-label"
      for="moduleFile">
      Version File
      <span class="lx-validation-warning">*</span>
    </label>
    <input
      #moduleFileSelected
      accept=".ipk"
      autocomplete="off"
      id="moduleFile"
      name="moduleFile"
      style="display: none"
      type="file"
      (change)="onSelectModule($event)" />
    <button
      class="input__file-icon x-btn lx-btn-small lx-btn-primary"
      (click)="moduleFileSelected.click()">
      Choose File
    </button>
    <div *ngIf="showFileInfo">
      <div class="input__module-name">
        <div>Name: {{ name }}</div>
        <span
          *ngIf="isModuleNameMisMatch"
          class="input__module-name__warning">
          Filename must match Module Name: '{{ moduleName }}'
        </span>
      </div>
      <div>Version: {{ version }}</div>
      <div>Platform: {{ platform }}</div>
    </div>
  </div>

  <div class="input">
    <label
      class="lx-label"
      for="signature">
      Version Signature
      <span class="lx-validation-warning">*</span>
    </label>
    <input
      #signatureFile
      accept=".sig"
      autocomplete="off"
      class="input__file-icon x-btn lx-btn-primary"
      id="signature"
      name="signature"
      style="display: none"
      type="file"
      (change)="onSelectSignature($event)" />
    <button
      class="input__file-icon x-btn lx-btn-small lx-btn-primary"
      (click)="signatureFile.click()">
      Choose File
    </button>
    <p *ngIf="signature">{{ signatureFile.files.item(0).name }}</p>
  </div>

  <div class="input">
    <label
      class="lx-label"
      for="configurationSchema">
      Configuration Schema JSON
    </label>
    <input
      #configurationSchema
      accept=".JSON"
      autocomplete="off"
      id="configurationSchema"
      name="configurationSchema"
      style="display: none"
      type="file"
      (change)="onSelectJsonUpload($event)" />
    <button
      class="input__file-icon x-btn lx-btn-small lx-btn-primary"
      (click)="configurationSchema.click()">
      Choose File
    </button>
    <p *ngIf="configJson">{{ configurationSchema.files.item(0).name }}</p>
  </div>

  <div class="input">
    <label
      class="lx-label"
      for="zsyncFile">
      Zsync Sidecar
    </label>
    <input
      #zsyncFileSelected
      accept=".zsync"
      autocomplete="off"
      id="zsyncFile"
      name="zsyncFile"
      style="display: none"
      type="file"
      (change)="onSelectZsync($event)" />
    <button
      class="input__file-icon x-btn lx-btn-small lx-btn-primary"
      (click)="zsyncFileSelected.click()">
      Choose File
    </button>
    <p *ngIf="zsyncFileName">{{ zsyncFileName }}</p>
  </div>
</div>

<div class="footer">
  <div class="footer__button-container">
    <button
      class="footer__button-container__close lx-btn lx-btn-secondary"
      (click)="close()">
      Cancel
    </button>
    <button
      class="footer__button-container__create lx-btn lx-btn-primary"
      id="submitModule"
      [disabled]="!canEnableAddButton || isLoading"
      (click)="createModuleVersion()">
      Add
    </button>
  </div>

  <dcc-module-spinner [isLoading]="isLoading"></dcc-module-spinner>
</div>
